module.exports = __webpack_public_path__ + "static/daddypossum_1_square-52bbf41ce5dcf6399007ba685a24d6bd.jpg";